import { colors } from './colors';
import { spacing } from './spacing';
import { typography } from './typography';
import { animation } from './animation';
import { Theme } from '../types';

export const rebrand2022Theme: Theme = {
  name: 'REBRAND2022',
  get legacy() {
    return undefined;
  },
  typography,
  colors,
  spacing,
  animation,
};
